<template>
	<v-dialog v-model="dialog" persistent max-width="800" scrollable>
		<v-card>
			<v-card-title class="justify-space-between pb-0">
				<div class="font-size-14 font-size-xs-11 cl-secondary">{{ articleType }}</div>
				<v-btn small text class="px-0 mr-n4" @click="modalHide">
					<v-icon color="red">mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text>
				<div class="py-5">
					<h1 class="primary--text text-capitalize" style="line-height: 120%;">{{ detailArticle.content_title }}</h1>
					<span class="d-flex align-center cl-secondary mt-3 mb-5"><v-icon dense class="cl-secondary mr-1">mdi-calendar-outline</v-icon>{{ detailArticle.content_input_datetime | tanggal }}</span>
					<v-img
						width="100%"
						:src="(detailArticle.content_image) ? detailArticle.content_image : '/assets/image/no-image-post.png'"
					></v-img>
					<div class="font-size-12 mt-5 black--text lighten-2" v-html="detailArticle.content_body"></div>
				</div>
			</v-card-text>
			<v-card-actions class="justify-center">
				<v-col cols="3">
					<v-btn depressed block color="primary" class="white--text rounded-lg text-capitalize" @click="modalHide">
						<v-icon small v-if="false">mdi-close</v-icon>
						<span>Tutup</span>
					</v-btn>
				</v-col>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
	props: ['articleType'],
	data () {
		return {
			dialog: false,
		}
	},
	computed: {
		...mapState('article', ['detailArticle']),
	},
	methods: {
		modalShow() {
			this.dialog = true
		},
		modalHide() {
			this.dialog = false
		},
	}
};
</script>